import { Record as record } from 'immutable';

import { construct, resolve } from '../../helpers/LinkMapper';
import Trip from '../order/Trip';

const defaults = {
    changeoverTicket: null,
    newTicket: null,
    changeover: false,
    changeoverTrip: null
};

class ChangeoverTicket extends record(defaults) {
    static fromJSON (json) {
        return construct(ChangeoverTicket, json, {
            changeoverTicket: json.changeoverTicket,
            newTicket: json.newTicket,
            changeover: json.changeover,
            changeoverTrip: resolve(json.changeoverTrip).as(Trip)
        });
    }

    isNewTicket (id) {
        return this.newTicket === id;
    }

    getOldFare () {
        return this.changeoverTrip.getFareByTicketId(this.changeoverTicket);
    }
}

export default ChangeoverTicket;



// WEBPACK FOOTER //
// ./src/records/changeover/Ticket.js